const breakpoints = {
  alpha: 0,
  beta: 420,
  charlie: 720,
  delta: 1080,
  echo: 1420,
}
let $window;

function setBreakPoint() {
  const windowWidth = $window.innerWidth();
  window.globals.breakpoint = Object.keys(breakpoints).slice().reverse().find((breakpoint) => windowWidth > breakpoints[breakpoint]);
}

export default function() {
  window.globals = {};
  $window = $(window);
  setBreakPoint();
  $window.on('resize', setBreakPoint);
}



// WEBPACK FOOTER //
// ./scripts/components/globals.js